module.exports = __webpack_public_path__ + "static/media/trash-icon.0c95ad24.svg";